module.exports = __webpack_public_path__ + "static/media/conf-app7.cb44696e.png";